import { createTheme } from './create-theme';

const defaultTheme = createTheme();

export { defaultTheme };
